import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route, Switch} from "react-router-dom";

import Simulacion from './Simulacion';

  
ReactDOM.render(
            <div>
            <Router>
            <Switch>
                <Route exact path="*">
                    <Simulacion />
                </Route>
            </Switch>
            </Router>
            </div>,
  document.getElementById("root")
);